import { fetcher } from "helpers/fetcher";

import { PaginationReq } from "../types";
import { TGetProfileListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserEmployeeList = async (payload: PaginationReq) => {
  return await fetcher<TGetProfileListRes, PaginationReq>(
    ENDPOINT.USER.USER_EMPLOYEE_LIST,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.USER_CLIENT_LIST.version,
      },
    }
  );
};

export const queryGetUserEmployeeList = async (payload: PaginationReq) => {
  return (await getUserEmployeeList(payload)).data;
};

queryGetUserEmployeeList._key = (payload: PaginationReq) => [
  ENDPOINT.USER.USER_EMPLOYEE_LIST.url,
  payload,
];
